import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_13} from 'styles/FontConstants';
import {ButtonLink, ButtonStyle} from 'ui-library/buttons/Button';

export default function StudyProductFeedbackLink(): JSX.Element {
  return (
    <ButtonLink
      text="Provide feedback"
      buttonStyle={ButtonStyle.LINK}
      href="https://airtable.com/shrIplDbQe0fOeNGW"
      target="_blank"
      rel="noopener noreferrer"
      className={css(styles.provideFeedbackButton)}
    />
  );
}

const styles = StyleSheet.create({
  provideFeedbackButton: {
    ...FONT_PROXIMA_13,
    ':focus': {textDecoration: 'none'},
  },
});
